<template>
  <sidebar
  :addTitle="$t('KPU.KeyProjectType.AddNew')"
  :editTitle="$t('KPU.KeyProjectType.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('KPU.KeyProjectType.Name')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProjectType.Name')"
              v-model="typeName"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="typeIsCapitalExpenseRequest" class="mb-2 mt-10">{{$t('KPU.KeyProjectType.IsCapitalExpenseRequest')}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>

import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "../../../../shared/components";


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      typeId: 0,
      typeName: "",
      typeIsCapitalExpenseRequest : false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, name, isCapitalExpenseRequest } = JSON.parse(JSON.stringify(this.data));
      this.typeId = id;
      this.typeName = name;
      this.typeIsCapitalExpenseRequest = isCapitalExpenseRequest;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.typeId = 0;
      this.typeName = "";
      this.typeIsCapitalExpenseRequest = false;
    },
    
    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.typeId,
            name: this.typeName,
            isCapitalExpenseRequest: this.typeIsCapitalExpenseRequest
          };

          this.$vs.loading();
         
          if (this.typeId !== null && this.typeId > 0) {
            this.$store.dispatch("kpu/updateKeyProjectType", obj).then((result) => {
              this.$emit("onKeyProjectTypeUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("kpu/addKeyProjectType", obj).then((result) => {
              this.$emit("onKeyProjectTypeInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
